<template>
  <!-- <div v-bind:style="{display:tabledata.length>0?'block':'none'}" > -->
  <div v-if="tabledata.length>0">
    <p style="font-weight:bold;font-size:1.5em">{{tabletitle}}</p>
    <p v-show="selecteditems.length>0">
      <el-button
        type="primary"
        :disabled="processing"
        @dblclick.native="approvemany('yes')"
      >同意所选 Approve selects</el-button>
      <el-button
        type="danger"
        :disabled="processing"
        @dblclick.native="approvemany('no')"
      >拒绝所选 Reject selects</el-button>
    </p>

    <vuetable
      ref="vuetable"
      :fields="tablefields"
      :api-mode="false"
      :data="tabledata"
      :css="{tableClass:'table table-sm table-hover'}"
      no-data-template
    >
    <!-- <VuetableRowHeader @onColumnHeaderClicked="asd('sd')"></VuetableRowHeader> -->
      <!-- <span > -->
        <el-checkbox
        slot="select" slot-scope="props"
          v-model="props.rowData.checkif"
          @change="checkboxselect(props.rowData.checkif,props.rowData._id)"
        ></el-checkbox>
      <!-- </span> -->
      <!-- <span slot="h__select">
        <el-checkbox  @change="selectall()"></el-checkbox>
      </span>-->

      <span slot="sq" slot-scope="props">{{props.rowIndex+1}}</span>
      <p slot="action" slot-scope="props">
        <el-button-group>
          <el-button
            :disabled="processing"
            type="success"
            size="mini"
            @click="$message('双击确认')"
            @dblclick.native="approve(props.rowData._id,'yes')"
          >确认</el-button>
          <el-button
            :disabled="processing"
            type="danger"
            size="mini"
            @click="$message('双击操作')"
            @dblclick.native="approve(props.rowData._id,'no')"
          >拒绝</el-button>
        </el-button-group>
      </p>
      <status slot="status" slot-scope="props" :rowData="props.rowData" :rowField="props.rowField"></status>
    </vuetable>
    <div v-if="showmore">
      <el-button type="text" @click="receivedmore">查看更多More...</el-button>
    </div>
    <div style="margin-bottom:50px;background-color:rgba(0,0,0,0.2)" v-if="tabledata.length===0">
      <p style="font-size:2em;font-weight:bold">无数据</p>
    </div>
  </div>
</template>

<script>
import Vuetable from "vuetable-2";
import moment from "moment";
import VuetableRowHeader from "vuetable-2/src/components/VuetableRowHeader.vue";
// import { fields } from "../presentation/vuetablefields.js";
// import {formatter} from "../presentation/utility/formatter"
import { fieldsprocess } from "zxg-table-fieldsprocess";
import status from "@/components/utility/commonfields/status";


export default {
  components: {
    VuetableRowHeader,
    Vuetable,
    status
  },
  props: ["collection", "tabletitle"],
  data() {
    return {
      pages:1,
      showmore:false,
      processing: false,
      tabledata: [],
      tablefields: [],
      selecteditems: []
    };
  },
  mounted() {
    this.received()
  },
  methods: {
    receivedmore(){
      this.pages=this.pages+1
      this.received()
    },
    received(){
          this.$axios
      .post(url + "received", { collection: this.collection,pages:this.pages})
      .then(res => {
        this.tablefields =  fieldsprocess(res.data.fields, "approval",this.$store)//extendedfields(res.data.fields);//
        this.tabledata = this.tabledata.concat(res.data.doc);
        if (res.data.doc.length > 0) {
          this.$emit("hasdata");
        }
        if(res.data.doc.length===20){
          this.showmore=true
        }
        if(res.data.doc.length!=20){
           this.showmore=false
        }
        //console.log(res.data)
      });
    },
    // headerclick(){alert("sdfdf")},
    checkboxselect(checkif, _id) {
      if (checkif) {
        this.selecteditems.push(_id);
      } else {
        let i = this.selecteditems.findIndex(function(val) {
          return val === _id;
        });
        this.selecteditems.splice(i, 1);
      }
    },

    approvemany(approval) {
      this.processing = true;
      this.$axios
        .post(url + "approvemany", {
          collection: this.collection,
          _ids: this.selecteditems,
          approval: approval
        })
        .then(res => {
          this.$message("提交成功");
          //this.$forceUpdate()
          this.$router.go();
        });
    },

    approve(id, approval) {
      this.processing = true;
      this.$axios
        .post(url + "approve", {
          collection: this.collection,
          id: id,
          approval: approval
        })
        .then(res => {
          this.processing = false;
          let index = this.tabledata.findIndex(obj => {
            return obj._id === id;
          });
          this.tabledata.splice(index, 1);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/received/approval.vue